import React, { FC } from 'react'
import dayjs from 'dayjs'
import { Box, Tooltip } from '@node-space/ui-components'
import { DateFormat } from 'constants/General'
import { ApprovalsProcessedBy } from 'types/approvals'

interface ApproversTooltipProps {
  processedBy: ApprovalsProcessedBy[]
  status: string
  children: string
}

export const ApproversTooltip: FC<ApproversTooltipProps> = ({ processedBy, status, children }) => {
  const filteredProcessedBy = processedBy?.filter(
    processedByDetail => processedByDetail?.status === status
  )

  if (!filteredProcessedBy?.length) return <>{children}</>

  const tooltipContent = (
    <>
      {filteredProcessedBy?.map(approver => (
        <Box key={approver?.email}>
          <span className="text-foreground-subdeud text-body-regular">
            {approver?.userFullName?.trim() || approver?.email},{' '}
            {dayjs(approver?.eventTime).format(DateFormat.DD_MMMM_YYYY)}
          </span>
        </Box>
      ))}
    </>
  )

  return (
    <Tooltip
      testId="approvers-tooltip"
      type="complex"
      position="bottom"
      bodyContent={tooltipContent}
    >
      <span>{children}</span>
    </Tooltip>
  )
}
